import { useMemo } from 'react';
import { FieldErrors } from 'react-hook-form';

/**
 * Maps React Hook Form field errors to section titles.
 *
 * @param errors - The formState.errors object from React Hook Form
 * @param fieldToSectionMap - A mapping of field name → section title (the same title used in <Section title="...">)
 * @returns Record<string, boolean> where keys are section titles and values indicate whether the section has errors
 */
export const useSectionErrors = (
    errors: FieldErrors,
    fieldToSectionMap: Record<string, string>
): Record<string, boolean> => {
    return useMemo(() => {
        const sectionErrors: Record<string, boolean> = {};
        for (const fieldName of Object.keys(errors)) {
            const sectionTitle = fieldToSectionMap[fieldName];
            if (sectionTitle) {
                sectionErrors[sectionTitle] = true;
            }
        }
        return sectionErrors;
    }, [errors, fieldToSectionMap]);
};
